export type InteractionEvent =
  | "area_guide_click"
  | "property_description_expand"
  | "map_tiles_loaded"
  | "saved_search_cta_clicked"
  | "saved_search_login_gate_shown"
  | "saved_search_already_saved_shown"
  | "saved_search_eligibility_blocked"
  | "saved_search_create_variant_started"
  | "saved_search_share_copied"
  | "saved_search_edit_criteria_clicked"
  | "property_detail_rescue_cta"
  | "recent_activity_offer_shown"
  | "recent_activity_offer_accepted"
  | "recent_activity_offer_dismissed"
  | "recent_activity_continue_search_clicked"
  | "checkout_canceled"
  | "checkout_succeeded"
  | "checkout_failed"
  | "checkout_pending_timeout"
  | "dunning_banner_shown"
  | "winback_cta_clicked"
  | "paywall_gate_shown"
  | "paywall_gate_clicked"
  | "auth_gate_shown"
  | "auth_gate_clicked"
  | "auth_page_viewed";

type InteractionProps = Record<string, string | number | boolean | undefined>;
const ANALYTICS_TIMEOUT_MS = 5_000;

function getCurrentPageUrl(includeSearch: boolean): string | null {
  if (typeof window === "undefined") {
    return null;
  }

  return `${window.location.origin}${window.location.pathname}${includeSearch ? window.location.search : ""}`;
}

export function trackInteraction(
  event: InteractionEvent,
  props: InteractionProps,
  options: { includeSearch?: boolean } = {},
) {
  if (typeof window === "undefined") {
    return;
  }

  try {
    const headers: Record<string, string> = {
      "Content-Type": "application/json",
    };

    try {
      const distinctId = window.posthog?.get_distinct_id?.();
      if (distinctId) headers["X-PostHog-Distinct-ID"] = distinctId;
    } catch {
      // PostHog access is best-effort.
    }

    try {
      const sessionId = window.getPostHogSessionId?.();
      if (sessionId) headers["X-PostHog-Session-ID"] = sessionId;
    } catch {
      // PostHog access is best-effort.
    }

    void fetch("/api/ping/event", {
      method: "POST",
      headers,
      body: JSON.stringify({
        event,
        props,
        pageUrl: getCurrentPageUrl(options.includeSearch ?? true),
      }),
      keepalive: true,
      signal: AbortSignal.timeout(ANALYTICS_TIMEOUT_MS),
    }).then((response) => response.body?.cancel()).catch(() => {
      // Fire-and-forget analytics should never affect UX
    });
  } catch {
    // Fire-and-forget analytics should never affect UX
  }
}
